export const UPDATE_OFFER_HEADER_SUCCESS = "UPDATE_OFFER_HEADER_SUCCESS";
export const UPDATE_OFFER_HEADER_STARTED = "UPDATE_OFFER_HEADER_STARTED";
export const UPDATE_OFFER_HEADER_FAILED = "UPDATE_OFFER_HEADER_FAILED";
